import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError, BehaviorSubject, from } from 'rxjs';
import { StorageService } from '../services/storage.service';
import { AuthenticationService } from '../services/authentication.service';
import { catchError, switchMap, filter, take, mergeMap } from 'rxjs/operators';
import { Network } from '@ngx-pwa/offline';
import { AuthFacade } from '../ngrx/auth/auth.facade';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { ErrorModalComponent } from '../shared/error-modal/error-modal.component';
import { SessionExpiredModalComponent } from '../shared/session-expired-modal/session-expired-modal.component';



@Injectable()
export class TokenInterceptor implements HttpInterceptor {
    constructor(
      private storage: StorageService,
      private auth: AuthenticationService,
      protected network: Network,
      protected authFacade: AuthFacade,
      public bsModalRef: BsModalRef,
      private modalService: BsModalService,
      private sessionExpiredModalService: BsModalService,
    ) { }

    private isRefreshing = false;
    private refreshTokenSubject: BehaviorSubject<any> = new BehaviorSubject<any>(null);

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return from(this.authFacade.getDataFromDB()).pipe(
          mergeMap(
            (data) => {
              if (request.url.includes('gcmicroapi') && data.access_token) {
                  request = this.addToken(request, data.access_token);
              }
              return next.handle(request).pipe(
                  catchError(
                      error => {
                          const initialState = {
                            errorStatus: `${error.status}: ${error.statusText}`,
                            errorMsg: error.message
                          };
                          if (error instanceof HttpErrorResponse && error.status === 401) {
                            console.log('====================================');
                            console.log('error', error.error.error_description);
                            console.log('====================================');
                            if (error.error !== undefined) {
                                if (error.error.error_description.indexOf('Invalid refresh token (expired)') > -1) {
                                    this.openSessionExpiredModal();
                                    return throwError(error);
                                }
                            }
                            return this.handle401Error(request, next, data);
                        } else {
                          if(request.url !== '/gcmicro/oauth/token'){
                            this.bsModalRef = this.modalService.show(ErrorModalComponent, {initialState});
                          }
                          return throwError(error);
                        }
                      }
                  )
              );
            }
          )
        );
    }

    private addToken(request: HttpRequest<any>, token: any) {
        return request.clone({
            setHeaders: {
                Authorization: `Bearer ${token}`,
                'X-Product-Id': 'ANG'
            }
        });
    }

    private handle401Error(request: HttpRequest<any>, next: HttpHandler, data: any) {
        if (!this.isRefreshing) {
            this.isRefreshing = true;
            this.refreshTokenSubject.next(null);
            return this.auth.refreshToken(data.refresh_token).pipe(
                switchMap((token: any) => {
                    if(token.error !== undefined && token.error.error_description.indexOf('Invalid refresh token (expired)') > -1) return [];
                    this.isRefreshing = false;
                    this.authFacade.insertDataToDB(token);
                    this.refreshTokenSubject.next(token.access_token);
                    return next.handle(this.addToken(request, token.access_token));
                }));
        } else {
            return this.refreshTokenSubject.pipe(
                filter(token => token != null),
                take(1),
                switchMap(jwt => {
                    return next.handle(this.addToken(request, jwt));
                }));
        }
    }

    private openSessionExpiredModal() {
      const initialState = {
          title: 'Session Expired'
      };
      this.sessionExpiredModalService.config.ignoreBackdropClick = true;
      this.sessionExpiredModalService.config.keyboard = false;
      this.bsModalRef = this.sessionExpiredModalService.show(SessionExpiredModalComponent, {initialState});
  }

}
